import { render } from "./TermofService.vue?vue&type=template&id=52accb4c&scoped=true"
import script from "./TermofService.vue?vue&type=script&lang=js"
export * from "./TermofService.vue?vue&type=script&lang=js"

import "./TermofService.vue?vue&type=style&index=0&id=52accb4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52accb4c"]])

export default __exports__